import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../lib/i18n';
import { BRAND } from '../lib/translations';

const ORDER = ['hu', 'en', 'de'];

export const Navbar = () => {
  const { t, lang, setLang } = useI18n();
  const [logoHidden, setLogoHidden] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const services = document.getElementById('services');
      if (services) {
        // Hide once the user reaches ~80vh before the services section
        const threshold = services.offsetTop - window.innerHeight * 0.6;
        setLogoHidden(window.scrollY > threshold);
      } else {
        setLogoHidden(window.scrollY > window.innerHeight * 0.4);
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 left-0 right-0 z-50 pointer-events-none`}
    >
      <div className="px-6 md:px-10 lg:px-14 pt-6 md:pt-8 flex items-start justify-end">
        <div className="pointer-events-auto flex items-center gap-1 text-[10px] tracking-[0.32em] uppercase font-body">
          {ORDER.map((code, i) => (
            <React.Fragment key={code}>
              <button
                onClick={() => setLang(code)}
                data-testid={`lang-${code}`}
                className={`px-1.5 py-1 transition-colors ${
                  lang === code ? 'text-peach' : 'text-cream/45 hover:text-cream'
                }`}
                aria-label={`Switch language to ${code.toUpperCase()}`}
              >
                {code.toUpperCase()}
              </button>
              {i < ORDER.length - 1 && <span className="text-cream/25">·</span>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Navbar;
